import Location from './location.connect'

export default Location
